module.exports = __webpack_public_path__ + "img/DE05889.4141fbc3.png";